module.exports = __webpack_public_path__ + "img/track_danger.b1a489ae.svg";